module.exports = __webpack_public_path__ + "img/mirana.83148b80.png";